<ng-content select="[slot='start']" class="pointer-events-none"></ng-content>
<ng-content class="pointer-events-none"></ng-content>
<ng-content select="[slot='icon-only']" class="pointer-events-none" vsButtonIcon></ng-content>
<ng-content select="[slot='end']" class="pointer-events-none"></ng-content>
